module.exports = __webpack_public_path__ + "materialdesignicons-webfont.woff2?927457ed7478ec7e1580a2b88116f9c3";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff2?v=4.7.95
// module id = 1215
// module chunks = 0